<cre-idle-dialog></cre-idle-dialog>
<app-navbar *ngIf="showDecorators"></app-navbar>
<div id="main-container">
  <cre-notification></cre-notification>
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="showDecorators"></app-footer>
